import { c as _c } from "react/compiler-runtime";
// Mono OG shell variant. Blue halftone raster with inline header chrome.
// For text-heavy surfaces — thesis quotes, plain commentary.

import type { ReactNode } from 'react';
import { OG_DIMENSIONS, OG_TOKENS } from '../../tokens';
import { OgDemoModeBadge } from '../chrome/og-demo-mode-badge';
import { OgHeaderChrome } from '../chrome/og-header-chrome';
import { OgShellBackground } from '../chrome/og-shell-background';
import { OgShellSlot } from '../chrome/og-shell-slot';
import { SHELL_METRICS } from '../shell-tokens';
interface VariantProps {
  children: ReactNode;
  eyebrow?: string | null;
  demoMode?: boolean;
}
export function ShellMono(props) {
  const $ = _c(12);
  const m = SHELL_METRICS.mono;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: OG_DIMENSIONS.width,
      height: OG_DIMENSIONS.height,
      position: "relative",
      display: "flex",
      flexDirection: "column",
      padding: m.inset,
      gap: m.contentGap,
      color: OG_TOKENS.gray50,
      fontFamily: "Geist, var(--font-geist-sans), system-ui, sans-serif",
      overflow: "hidden"
    };
    t1 = <OgShellBackground variant="mono" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const t2 = props.eyebrow ?? m.eyebrow;
  let t3;
  if ($[2] !== t2) {
    t3 = <OgHeaderChrome layout={m.headerLayout} logoSize={m.logoSize} eyebrow={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props.children) {
    t4 = <OgShellSlot padding={m.slotPadding} contentJustify={m.slotContentJustify}>{props.children}</OgShellSlot>;
    $[4] = props.children;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props.demoMode) {
    t5 = props.demoMode === true && <OgDemoModeBadge />;
    $[6] = props.demoMode;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div style={t0}>{t1}{t3}{t4}{t5}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}